module.exports = __webpack_public_path__ + "../resources/img/ic_re_disconnected.bb5717c6.png";